import React, { useState } from 'react';
import { Menu, Search, User, ChevronDown, ChevronUp, LogOut } from 'lucide-react'; // Import ChevronUp
import { Link, useNavigate } from 'react-router-dom';
import logo from "../assets/digitalparag/DigirtalParag.png";

const Aheader = ({ setAdminSidebarOpen }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate(); // Use navigate to redirect
  const adminId = localStorage.getItem("adminId");
  const adminName = localStorage.getItem("adminName");

  const handleLogout = () => {
    // Clear auth data (assuming stored in local storage)
    localStorage.removeItem('auth');
    localStorage.removeItem("adminId"); // Clear auth from localStorage
    localStorage.removeItem("adminName"); // Clear auth from localStorage
    localStorage.removeItem("adminEmail"); // Clear auth from localStorage

    // Redirect to sign-in page after logout
    navigate('/admin-login');
  };


  return (
    <header className="bg-gradient-to-r from-white to-orange-200 shadow-md w-full px-4 lg:px-6 h-16 flex justify-between items-center border-b border-gray-200"
    >
      {/* Sidebar Toggle Button for Mobile */}
      <button
        className="lg:hidden text-gray-500 focus:outline-none"
        onClick={() => setAdminSidebarOpen(true)}
      >
        <Menu className="h-6 w-6" />
      </button>

      {/* Dashboard Title */}
      <div className="flex-1 text-center lg:text-left">
        <img className='h-16' src={logo} alt="" />
      </div>


      {/* Add space between search and profile */}
      <div className="ml-6"></div>

      {/* Profile Dropdown */}
      <div className="relative">
        <button
          className={`flex items-center focus:outline-none text-black hover:text-red-900 transition-colors ${dropdownOpen ? 'active' : ''}`}
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <User className={`h-7 w-7 ${dropdownOpen ? 'animate-blink' : ''}`} /> {adminName}
          {dropdownOpen ? (
            <ChevronUp className="h-4 w-4 ml-1" />
          ) : (
            <ChevronDown className="h-4 w-4 ml-1" />
          )}
        </button>

        {/* Dropdown Menu */}
        {dropdownOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-white border rounded-lg shadow-lg py-2 z-50">
            <button
              className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full transition-colors"
              onClick={handleLogout} // Trigger logout function
            >
              <LogOut className="h-4 w-4 mr-2" />
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Aheader;
